import { configureStore } from '@reduxjs/toolkit'
import preChecksFiltersSlice from '../Pages/PreChecks/store/preChecksFiltersSlice'

// Persist the list filters in sessionStorage so they survive both leaving the page (open
// a TruCheck detail, come back) AND a tab refresh. sessionStorage is scoped to the browser
// TAB: filters are NOT shared across tabs or the whole browser (which localStorage would
// do) — a new tab starts from the slice defaults, exactly as required.
const SESSION_KEY = 'verifiedid.preChecksFilters'

const hasSessionStorage = () => {
    try {
        return typeof window !== 'undefined' && !!window.sessionStorage
    } catch {
        return false
    }
}

const loadPersistedState = () => {
    if (!hasSessionStorage()) return undefined
    try {
        const raw = window.sessionStorage.getItem(SESSION_KEY)
        if (!raw) return undefined
        const parsed = JSON.parse(raw)
        // Only trust a well-formed snapshot (the draft/applied filter groups); anything
        // else falls back to slice defaults.
        if (!parsed || typeof parsed !== 'object'
            || typeof parsed.draft !== 'object' || typeof parsed.applied !== 'object') {
            return undefined
        }
        return { preChecksFilters: parsed }
    } catch {
        return undefined
    }
}

export const store = configureStore({
    reducer: {
        preChecksFilters: preChecksFiltersSlice,
        // below reducers are for other pages, if needed
    },
    preloadedState: loadPersistedState(),
})

// Save on every change, debounced (the search box dispatches on each keystroke).
if (hasSessionStorage()) {
    let saveTimeout
    store.subscribe(() => {
        clearTimeout(saveTimeout)
        saveTimeout = setTimeout(() => {
            try {
                window.sessionStorage.setItem(
                    SESSION_KEY,
                    JSON.stringify(store.getState().preChecksFilters),
                )
            } catch {
                // Best-effort: ignore write failures (storage disabled / quota exceeded).
            }
        }, 200)
    })
}
